import script from "./FirmalarScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./FirmalarScreen.vue?vue&type=script&setup=true&lang=js"

import "./FirmalarScreen.vue?vue&type=style&index=0&id=52c2031b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52c2031b"]])

export default __exports__